module.exports = __webpack_public_path__ + "img/Retail1Phone.84bca33e.png";